import { useEffect, useRef, useState } from "react"
import { FileData } from "./components/dataFile/types"
import { ObjectGeneric } from "../../../../utils/types/generals"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"
import { filesManagerServiceFetch } from "../../../../utils/constants/callService"
import { UserCreator } from "./components/file/types"
import { formatFileDetail, formatListUsersPermissions } from "../../../../service/filesManager/format"
import { RequestErrors, Status, Types } from "../../../../utils/enums"
import { getLocalStorage } from "../../../../utils/crud/crypt"
import { handleAllErrors } from "../../../../utils/methods/handleErrors"
import { useFilter } from "../../../../hooks/filter"
import { returnQuery } from "../../../../utils/methods/returnQuery"


const useBody = () => {

    const { id: fileId } = useParams()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [file, setFile] = useState<FileData | File>({ createDate: '', editDate: '', name: '', size: '', type: '', url: '' })
    const [keyFile, setKeyFile] = useState<string>('');
    const [errors, setErrors] = useState<Record<string, string>>({})
    const [data, setData] = useState<ObjectGeneric>({})
    const [totalPages, setTotalPages] = useState(0)
    const refTime = useRef<NodeJS.Timeout | null>(null)
    const [solictedUser, setSolicitedUsers] = useState<{ id: number; name: string }[]>([])
    const [row, setRow] = useState<{
        name: string;
        roleName: string;
        areaName: string;
        departmentName: string;
        userTypeDescription: string;
        seeFile: boolean;
        downloadFile: boolean;
    }[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [loadingDetail, setLoadingDetail] = useState(false)
    const [userCreator, setUserCreator] = useState<UserCreator>({ area: [], department: [], name: '', role: '', userType: '' })
    const [statusFile, setStatusFile] = useState(Status.ACTIVE)
    const [showOptions, setShgowOptions] = useState(false)
    const state: { id: number, role: number } = getLocalStorage()
    const [canDownload, setCanDownload] = useState(false)
    const [canSee, setCanSee] = useState(false)


    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
    }>({
        open: false,
        title: t('filesManager.modal.titles.confirmation'),
        description: '',
        confirm: () => { },
    })

    const [snackbarOpen, setSnackbarOpen] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const closeSnackBarOpen = () => {
        setSnackbarOpen(prev => ({ ...prev, open: false }))
    }

    const closeModalIndex = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const getFileDatail = async () => {
        setLoadingDetail(true)
        const response = await filesManagerServiceFetch.getFileById({ id: Number(fileId) })

        const { userCreator, solictedUser, status, file, data, showOptions, canDownload, key, canSee } = formatFileDetail({ response, userId: state.id, role: state.role })

        setUserCreator(userCreator)
        setSolicitedUsers(solictedUser)
        setStatusFile(status)
        setFile(file)
        setKeyFile(key)
        setData(data)
        setShgowOptions(showOptions)
        setCanDownload(canDownload)
        setCanSee(canSee)


        setLoadingDetail(false)
    }

    const getUsersList = async () => {
        setIsLoading(true)
        const response = await filesManagerServiceFetch.getListUsersPermmisions({ id: Number(fileId), query: returnQuery({ ...filterPermissions.query, filter: filterPermissions.query.filter?.replaceAll('+', '%2B') }) })

        const { row } = formatListUsersPermissions({ response: response.items })

        setRow(row)

        setIsLoading(false)
        setTotalPages(response.totalPages)
    }

    const filterPermissions = useFilter({ formatFilter: {} })

    const activateOrDesactivate = async () => {
        const response = await filesManagerServiceFetch.enableOrDisableFile({ id: Number(fileId) });

        if (response.code == '01') {
            setSnackbarOpen(prev => ({
                ...prev,
                open: true,
                message: t(`filesManager.snackbar.${statusFile == Status.INACTIVE ? 'activateFile' : 'desactivateFile'}`),
                type: Types.SUCCESS
            }))
            getFileDatail()
        } else {
            setSnackbarOpen(prev => ({
                ...prev,
                open: true,
                message: t(`filesManager.snackbar.${statusFile == Status.INACTIVE ? 'noActivateFile' : 'noDesactivateFile'}`),
                type: Types.ERROR
            }))
        }

    }

    const deleteFile = async () => {

        const response = await filesManagerServiceFetch.deleteFile(Number(fileId));

        if (response.code == '00') {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: t('filesManager.snackbar.delete.success.unique'), type: Types.SUCCESS }))
            setTimeout(() => {
                navigate('/dashboard/filesManager/main');
            }, 3000);
        } else {
            setSnackbarOpen(prev => ({ ...prev, open: true, message: handleAllErrors(response?.code as RequestErrors, t), type: Types.ERROR }))
        }
    }

    useEffect(() => {
        getFileDatail()
    }, [fileId])

    useEffect(() => {
        if (refTime.current) { clearTimeout(refTime.current) }

        refTime.current = setTimeout(() => {
            getUsersList()
        }, 300)
    }, [filterPermissions.query.all])

    return {
        file,
        data,
        errors,
        closeModalIndex,
        modal,
        solictedUser,
        row,
        isLoading,
        setData,
        setErrors,
        setFile,
        loadingDetail,
        userCreator,
        statusFile,
        showOptions,
        activateOrDesactivate,
        deleteFile,
        snackbarOpen,
        closeSnackBarOpen,
        canDownload,
        keyFile,
        canSee,
        filterPermissions,
        totalPages
    }
}



export { useBody }